import { createSlice } from "@reduxjs/toolkit";
import fetchResource from "../../utils/fetch-wrapper";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    error: null,
    success: null,
    loading: false,
    auth: { status: false, token: null },
    user: null,
  },
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.auth = false;
      state.user = null;
    },
    loginSuccess: (state, { payload }) => {
      const { userData, auth } = payload;
      state.user = userData.data;
      state.auth = auth;
      state.loading = false;
      state.success = true;
    },
    loginFailed: (state, { payload }) => {
      state.user = null;
      state.error = payload;
      state.loading = false;
    },
    setUserToState: (state, { payload }) => {
      state.user = payload;
    },
    setAuthToState: (state, { payload }) => {
      if (payload) {
        state.auth = payload;
      }
    },
    logout: (state) => {
      state.user = null;
      state.auth = { status: false, token: null };
      localStorage.removeItem("user");
      localStorage.removeItem("auth");
    },
  },
});

export const {
  loginStart,
  loginSuccess,
  loginFailed,
  setUserToState,
  setAuthToState,
  logout,
} = authSlice.actions;

const loginUser = (email, password) => {
  return fetchResource("user/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: {
      email,
      password,
    },
  });
};

export const loginUserThunk = (user) => async (dispatch) => {
  dispatch(loginStart());
  loginUser(user.email, user.password)
    .then((userData) => {
      if (userData.error === undefined) {
        localStorage.setItem("user", JSON.stringify(userData));
        const auth = {
          status: true,
          token: userData.token,
        };
        localStorage.setItem("auth", JSON.stringify(auth));
        dispatch(loginSuccess({ userData, auth }));
      } else {
        dispatch(loginFailed("* " + userData.error));
      }
    })
    .catch((err) => {
      console.log(err);
      dispatch(loginFailed(err.toString()));
    });
};

export const selectUser = (state) => state.auth.user;
export const selectAuth = (state) => state.auth.auth;
export const selectLoading = (state) => state.auth.loading;
export const selectError = (state) => state.auth.error;
export const selectSuccess = (state) => state.auth.success;
export const selectLoginSuccessfull = (state) => state.auth.loginSuccessfull;

export default authSlice.reducer;
